package com.bikompanion.data.gbfs

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
internal data class GbfsVehicleTypeCountDto(
    @SerialName("vehicle_type_id") val vehicleTypeId: String,
    val count: Int = 0,
)
